/* eslint-disable react/prop-types */
import { Box, TableCell, TableRow } from "@mui/material";
// import moment from "moment/moment";
import React from "react";
import tableStyle from "../../theme/styles/table";
// import { getOSCollective } from "../../utils";
import { isEmptyObj } from "../../utils/helper";
import Button from "../common/Button";
import { style } from "./styles";

function GohonzonHandover({ member, onHandoverApplication }) {
  if (isEmptyObj(member) || isEmptyObj(member.createdByMember)) {
    return null;
  }
  return (
    <TableRow style={tableStyle.tableRow}>
      <TableCell
        style={{
          ...style.Cell,
          color: "#043D90",
          fontWeight: "600",
          paddingLeft: "30px",
        }}
      >
        {member.id}
      </TableCell>
      <TableCell style={{ ...style.Cell, paddingLeft: "30px" }}>
        {member.numberOfApplications || "-"}
      </TableCell>
      <TableCell style={{ ...style.Cell, paddingLeft: "90px" }}>
        {member.numberOfAllottedApplications || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {member.areaName || "-"}/ {member.zoneName || "-"}/{" "}
        {member.regionName || "-"}
      </TableCell>
      <TableCell style={{ color: "#8C8C8C" }}>
        <Box style={style.flexC}>
          <Button
            variant="outlined"
            onClick={() => onHandoverApplication(member)}
            style={{ ...style.actionBtn, width: "100px" }}
            label="HANDOVER"
          />
        </Box>
      </TableCell>
    </TableRow>
  );
}

export default GohonzonHandover;
